import React from "react";
import MainLayout from "../layouts";
import { routes } from "./PageRoutes";
// import ProtectedLayout from "./ProtectedLayout";
import Inquiry from "../modules/Inquiry";
import Login from "../modules/Auth/Login";
import Loader from "../components/loader";
import { Toaster } from "react-hot-toast";
import Dashboard from "../modules/Dashboard";
import Register from "../modules/Auth/Register";
import VerifyOtp from "../modules/Auth/VerifyOtp";
import { AuthProvider } from "../context/AuthContext";
import ResetPassword from "../modules/Auth/ResetPassword";
import { LoaderProvider } from "../context/LoaderContext";
import AddProperty from "../modules/Dashboard/AddProperty";
import ForgotPassword from "../modules/Auth/ForgotPassword";
import PropertyDetail from "../modules/Dashboard/PropertyDetail";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const AppRoutes = () => (
  <AuthProvider>
    <LoaderProvider>
      <Loader />
      <Router>
        <Routes>
          <Route path={routes.login} element={<Login />} />
          <Route path={routes.register} element={<Register />} />
          <Route path={routes.forgotPasswordEmail} element={<ForgotPassword/>}/>
          <Route path={routes.verifyOtp} element={<VerifyOtp/>}/>
          <Route path={routes.resetPassword} element={<ResetPassword/>}/>

          <Route path={routes.home} element={<MainLayout />}>
            <Route exact path={routes.home} element={<Dashboard />} />
            <Route exact path={routes.npaInquiries} element={<Inquiry/>}/>
            <Route exact path={routes.addNpaProperties} element={<AddProperty/>}/>
            <Route exact path={routes.editNpaProperties} element={<AddProperty/>}/>
            <Route exact path={routes.viewNpaProperties} element={<PropertyDetail/>}/>
          </Route>
          
        </Routes>
      </Router>
      <Toaster position="top-right" reverseOrder={false} />
    </LoaderProvider>
  </AuthProvider>
);

export default AppRoutes